import { t } from '@web/i18n';
import { Input } from '@web/ui/core';
import { PremisesCheck, PremisesField } from './premises_field';
import type { PremisesForm } from './premises_form';

interface PremisesLimitsFieldsProps {
  form: PremisesForm;
  canManage: boolean;
  onChange: (next: Partial<PremisesForm>) => void;
}

export function PremisesLimitsFields({
  form,
  canManage,
  onChange: patch,
}: Readonly<PremisesLimitsFieldsProps>): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-end gap-2">
      <PremisesField id="premises-redeye-start" label={t('mice.premises.redEyeStart')}>
        <Input
          id="premises-redeye-start"
          type="time"
          value={form.redEyeStart}
          disabled={!canManage}
          onChange={(e) => {
            patch({ redEyeStart: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesField id="premises-redeye-end" label={t('mice.premises.redEyeEnd')}>
        <Input
          id="premises-redeye-end"
          type="time"
          value={form.redEyeEnd}
          disabled={!canManage}
          onChange={(e) => {
            patch({ redEyeEnd: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesField id="premises-redeye-arrival" label={t('mice.premises.redEyeArrivalUntil')}>
        <Input
          id="premises-redeye-arrival"
          type="time"
          value={form.redEyeArrivalUntil}
          disabled={!canManage}
          onChange={(e) => {
            patch({ redEyeArrivalUntil: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesField id="premises-preferred" label={t('mice.premises.preferredDepartureFrom')}>
        <Input
          id="premises-preferred"
          type="time"
          value={form.preferredDepartureFrom}
          disabled={!canManage}
          onChange={(e) => {
            patch({ preferredDepartureFrom: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesField id="premises-threshold" label={t('mice.premises.savingsThreshold')}>
        <Input
          id="premises-threshold"
          type="number"
          min={0}
          value={form.savingsThreshold}
          disabled={!canManage}
          onChange={(e) => {
            patch({ savingsThreshold: e.target.value });
          }}
        />
      </PremisesField>
      <PremisesCheck
        label={t('mice.premises.checkedBaggage')}
        checked={form.checkedBaggage}
        disabled={!canManage}
        onChange={(on) => {
          patch({ checkedBaggage: on });
        }}
      />
      <PremisesCheck
        label={t('mice.premises.arrivalDayBefore')}
        checked={form.arrivalDayBefore}
        disabled={!canManage}
        onChange={(on) => {
          patch({ arrivalDayBefore: on });
        }}
      />
    </div>
  );
}
